import React, { Suspense, useState, useEffect } from "react"
import SmartForm from "../munis/default/smart-form/smart-form"
// import { useMuniContext } from "strview-common"

const MuniSmartForm = ({ id, muniName, isPublic }) => {
    const [Component, setComponent] = useState(null)
    // const { getMuniId } = useMuniContext()
    // const muniId = getMuniId()
    const muniId = muniName

    useEffect(() => {
        const camelCaseMuniId = muniId.replace(/-([a-z])/g, g => g[1].toUpperCase())
        import("../munis/smart-form-components-router")
            .then((components) => {
                setComponent(() => components[camelCaseMuniId] || components["SmartForm"])
            })
            .catch(() => {
                setComponent(() => SmartForm)
            })
    }, [muniId])

    if (!Component) {
        return <div>Loading...</div>
    }

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Component id={id} muniName={muniName} isPublic={isPublic} />
        </Suspense>
    )
}

export default MuniSmartForm